<template>
	<div class="PagePartner">
		<div v-if="!($route.name.match(/-chart/) || $route.name.match(/-editor/)) && title">
			<div class="row margin-bottom-medium">
	    		<div class="col-xs-12">
	    			<h1 class="st-headline st-headline--1">{{ title }}</h1>
	    		</div>
	    	</div>

			<div v-if="edituser && edituser.fields">
				<FieldForm
				:cancelable="true"
				:isnew="!edituser.id || edituser.id == 'new'"
				:formfields="edituser.fields"
				@save="save"
				@create="create"
				@cancel="$router.push({ name: 'partner-list' })">
				</FieldForm>
			</div>

			<UserSimpleList v-if="edituser.managers" :users="edituser.managers" :title="'Partner Leader'" :newlink="edituser.urls.new_leader" :simpleusers="true" />
			<UserSimpleList v-if="edituser.employers" :users="edituser.employers" :title="'Partner Sales'":newlink="edituser.urls.new_user" :simpleusers="true" />
			<UserSimpleList v-if="edituser.customers" :users="edituser.customers" :title="'Customers'" :simpleusers="true" />
		</div>

		<router-view></router-view>
	</div>
</template>

<script>

import FieldForm from '@/components/form/FieldForm';
import UserSimpleList from '@/components/UserSimpleList';
import help_user from '@/helpers/user';
import help_rest from '@/helpers/rest';

export default {
	name: 'PagePartner',
	components: {
		FieldForm, UserSimpleList
	},
	props: ['id'],
	data: function () {
		return {
			loading: false
		}
	},
	computed: {
		title: help_user.editusertitle,
		edituser(){
			return this.$store.getters.edituser;
		}
	},
	created(){this.update();},
	mounted(){this.update();},
	updated(){
		if(!this.$store.getters.loadings.partner && this.$store.getters.edituser && this.$store.getters.edituser.id != this.id){
			this.update();
		}
	},
	destroyed(){
		this.reset();
	},
	methods: {
		...help_rest,
		reset(){
			this.$store.commit('RESET_EDITUSER');
			this.$store.commit('RESET_ACTIVE_FIELD');
			this.$store.commit('RESET_PRESENTATIONID');
			this.$store.commit('UNSET_PRESENTATION');
			this.$store.commit('UNSET_ADDABLECHARTS');
			this.$store.commit('UNSET_CHARTS');
		},
		save(payload){
			var self = this;
			if(self.id && self.id == 'new') return this.create(payload);
			self.restpatch('/api/v1/partners/' + self.id, payload, 'customer');
		},
		create(payload){
			var self = this;
			if(self.id && self.id != 'new') return this.save(payload);
			self.restput('/api/v1/partners/' + self.id, payload, 'customer');
		},
		update: function(){
			var self = this,
				url = '/api/v1/partners/' + this.id;

			if(self.$store.getters.loadings.partner) return;
			if(self.$store.getters.edituser && self.$store.getters.edituser.id == this.id) return;

			if(self.id == 'new') {
				self
					.restoptions(url, 'partner')
					.then(data => {
						self.$store.dispatch('SET_EDITUSER', data);
					})
			} else {
				self
					.restget(url, 'partner')
					.then(data => {
						self.$store.dispatch('SET_EDITUSER', data);
					});
			}
		}
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/PagePartner.vue